define('geo/trig',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.mod360 = exports.toRadians = exports.toDegrees = void 0;
    /**
     * Convert radians to degrees
     */
    function toDegrees(degrees) {
        return degrees * 180 / Math.PI;
    }
    exports.toDegrees = toDegrees;
    /**
     * Convert degrees to radians
     */
    function toRadians(degrees) {
        return degrees * Math.PI / 180;
    }
    exports.toRadians = toRadians;
    /**
     * Normalize an angle in degrees into the normal [-180,180) range of longitude
     */
    function mod360(degrees) {
        return (degrees % 360 + 540) % 360 - 180;
    }
    exports.mod360 = mod360;
});
//# sourceMappingURL=/assets/javascripts/geo/trig.js.map;
